import { IReportColumnDef } from '../../../shared/shared-models/reports/report-column.interface';
import { ReportValueType } from '../../../shared/shared-models/reports/report-value-type.enum';

/**
 * Column ids available on the completed stock take summary PDF.
 * Sourced from {@link IStockTakeFinalFigure} snapshot fields only.
 */
export enum StockTakeReportColumnId {
  code = 'code',
  description = 'description',
  qtyCounted = 'qtyCounted',
  timesCounted = 'timesCounted',
  binLocation = 'binLocation',
  delColQty = 'delColQty',
  onhand = 'onhand',
  movement = 'movement',
  delColMovement = 'delColMovement',
  variance = 'variance',
  latestCost = 'latestCost',
  avCost = 'avCost',
  randVariance = 'randVariance',
  countedByEmail = 'countedByEmail',
}

/**
 * Report column definitions for completed stock take summaries.
 */
export const STOCK_TAKE_SUMMARY_REPORT_COLUMNS: IReportColumnDef[] = [
  {
    id: StockTakeReportColumnId.code,
    label: 'Code',
    defaultSelected: true,
    widthWeight: 1.2,
    valueType: ReportValueType.string,
  },
  {
    id: StockTakeReportColumnId.description,
    label: 'Description',
    defaultSelected: true,
    widthWeight: 2.4,
    valueType: ReportValueType.string,
  },
  {
    id: StockTakeReportColumnId.binLocation,
    label: 'Bin',
    defaultSelected: false,
    widthWeight: 1,
    valueType: ReportValueType.string,
  },
  {
    id: StockTakeReportColumnId.qtyCounted,
    label: 'Qty Counted',
    defaultSelected: true,
    widthWeight: 1,
    valueType: ReportValueType.quantity,
    includeInTotals: true,
  },
  {
    id: StockTakeReportColumnId.timesCounted,
    label: 'Times Counted',
    defaultSelected: false,
    widthWeight: 1,
    valueType: ReportValueType.number,
  },
  {
    id: StockTakeReportColumnId.delColQty,
    label: 'Del-Col',
    defaultSelected: false,
    widthWeight: 1,
    valueType: ReportValueType.quantity,
    includeInTotals: true,
  },
  {
    id: StockTakeReportColumnId.onhand,
    label: 'On Hand',
    defaultSelected: true,
    widthWeight: 1,
    valueType: ReportValueType.quantity,
    includeInTotals: true,
  },
  {
    id: StockTakeReportColumnId.movement,
    label: 'Movement',
    defaultSelected: false,
    widthWeight: 1,
    valueType: ReportValueType.quantity,
    includeInTotals: true,
  },
  {
    id: StockTakeReportColumnId.delColMovement,
    label: 'Del Col Mov',
    defaultSelected: false,
    widthWeight: 1,
    valueType: ReportValueType.quantity,
    includeInTotals: true,
  },
  {
    id: StockTakeReportColumnId.variance,
    label: 'Variance',
    defaultSelected: true,
    widthWeight: 1,
    valueType: ReportValueType.quantity,
    includeInTotals: true,
  },
  {
    id: StockTakeReportColumnId.latestCost,
    label: 'Latest Cost',
    defaultSelected: false,
    widthWeight: 1,
    valueType: ReportValueType.currency,
  },
  {
    id: StockTakeReportColumnId.avCost,
    label: 'Avg Cost',
    defaultSelected: false,
    widthWeight: 1,
    valueType: ReportValueType.currency,
  },
  {
    id: StockTakeReportColumnId.randVariance,
    label: 'Rand Variance',
    defaultSelected: true,
    widthWeight: 1.2,
    valueType: ReportValueType.currency,
    includeInTotals: true,
  },
  {
    id: StockTakeReportColumnId.countedByEmail,
    label: 'Counted By',
    defaultSelected: false,
    widthWeight: 1.4,
    valueType: ReportValueType.string,
  },
];
